import { render, staticRenderFns } from "./DealPromotersCard.vue?vue&type=template&id=5b0332ba&scoped=true&"
import script from "./DealPromotersCard.vue?vue&type=script&lang=js&"
export * from "./DealPromotersCard.vue?vue&type=script&lang=js&"
import style0 from "./DealPromotersCard.vue?vue&type=style&index=0&id=5b0332ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0332ba",
  null
  
)

export default component.exports